<template>
  <van-popup get-container="#app" class="pop-content" v-model="giftPopShow" :close-on-click-overlay="false" position="bottom" :style="{ height: '85%' }">
    <div class="gift-all">
      <div class="pop-bottom">
        <div v-if="userGiftList.length === 0">
          <div>您暂时还没有新年礼哦~</div>
        </div>
        <div class="pop-details-wrap" v-else>
          <div class="pop-details" v-for="(item, index) in userGiftList" :key="index">
            <div class="gift-name">{{item.prizeName}}</div>
            <div class="gift-time">获得时间：{{parseTime(item.attendTime, '{y}-{m}-{d}')}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="pop-close" @click="closePop()"></div>
  </van-popup>
</template>
<script>
import { commonUtils } from '@/utils/common'
export default {
  props: ['userGiftList'],
  data () {
    return {
      giftPopShow: false
    }
  },
  methods: {
    parseTime: commonUtils.parseTime,
    popAppear () {
      this.giftPopShow = true
    },
    closePop () {
      this.giftPopShow = false
      this.$emit('closePop')
    }
  }
}
</script>
<style lang="less" scoped>
.pop-content {
  overflow: hidden;
  background-color: rgba(0,0,0,.1);
  pointer-events: none;
  .gift-all {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 375px;
    height: 413px;
    background-image: url('../../../assets/images/new-year/my-gift.png');
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .pop-bottom {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
    pointer-events: auto;
    .pop-details-wrap {
      width: 100%;
      height: 120px;
      overflow-y: auto;
      padding: 0px 40px;
      box-sizing: border-box;
      .pop-details {
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
      }
      .gift-name {
        width: 45%;
      }
      .gift-time {
        flex: 1;
        text-align: right;
      }
    }
  }
  .pop-close {
    width: 28px;
    height: 28px;
    bottom: 10%;
    margin: 20px auto 0;
    background-image: url('../../../assets/images/new-year/close.png');
    background-size: 100%;
    background-repeat: no-repeat;
    pointer-events: auto;
  }
}

</style>
